import { html } from 'htm/preact'

export function LoadingSpinner({ size = 'medium' }) {
  const sizeClasses = {
    small: 'w-4 h-4',
    medium: 'w-8 h-8',
    large: 'w-12 h-12'
  }

  return html`
    <div class="flex items-center justify-center">
      <div class="${sizeClasses[size]} border-2 border-gray-200 dark:border-gray-700 border-t-primary-500 rounded-full animate-spin"></div>
    </div>
  `
}